import { useMemo, useState } from 'react';
import { Dropdown } from '@appsumo/dorado-react';
import clsx from 'clsx';

import { COUNTRIES_LIST } from '~/constants/checkout';
import { COUNTRIES_WITH_UNICODE_FLAGS } from '~/constants/global';
import { useMountEffect } from '~/hooks/utils';
import { CountrySelectionProps } from '~/types/global';

export function CountrySelection({
  selectedCountry,
  onSelect,
  showUnicodeFlag,
  hideBorder,
  disabled,
  className,
}: Readonly<CountrySelectionProps>) {
  const [mounted, setMounted] = useState(false);
  const options = useMemo(() => {
    if (!showUnicodeFlag) {
      return COUNTRIES_LIST;
    }

    return COUNTRIES_WITH_UNICODE_FLAGS;
  }, [showUnicodeFlag]);

  // Issues with hydration i think because of the unicode flags
  useMountEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  return (
    <div className={className}>
      <Dropdown
        options={options}
        defaultValue={
          options.find((c) => c.value === selectedCountry) || options[0]
        }
        onClick={onSelect}
        heightLimit={200}
        hideBorder={hideBorder}
        disabled={disabled}
        // @ts-ignore-next-line
        menuClassName={clsx(showUnicodeFlag && 'w-80')}
      />
    </div>
  );
}
